<template>
  <div :class="[$style.tree]">
    <!-- 트리 영역 -->
    <div :class="[$style.h100, 'lnb-nav']">
      <div class="search">
        <w-search-field @search="filterTree"/>
      </div>
      <el-radio-group class="search tree-type-radio" style="margin-top: 15px; width: 100%;" v-model="activeTreeType">
        <el-radio-button style="width: 50%;" :label="treeType.LOG_FILTER"><span>필터</span></el-radio-button>
        <el-radio-button style="width: 50%;" :label="treeType.LOG_INDEX"><span>저장소</span></el-radio-button>
      </el-radio-group>
      <div style="margin-top:15px; height:calc(100% - 135px); width:100%;" v-loading="filterTreeLoading || indexTreeLoading">
        <el-scrollbar>
          <w-log-filter-tree style="padding-left:18px;" ref="filterTree" v-show="activeTreeType === treeType.LOG_FILTER" :keyword="keyword" :tree-types="treeTypes"
          @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode" />
          <w-log-index-tree style="padding-left:18px;" ref="indexTree" v-show="activeTreeType === treeType.LOG_INDEX" :keyword="keyword" :tree-types="treeTypes"
          @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode" />
        </el-scrollbar>
      </div>
    </div>
    <!-- side-footer -->
    <el-row v-if="userInfo.managerType === 'ADMIN'" type="flex" justify="center" align="middle" :class="$style['btn-bar']">
      <div>
        <el-button-group>
          <el-button @click="openFilterAddPopup">필터 추가</el-button>
          <el-button @click="openFilterSettingPopup">필터 편집</el-button>
        </el-button-group>
      </div>
    </el-row>
    <w-log-filter-setting-popup ref="filterPopup" @reload-tree-data="reloadTreeData" />
    <w-log-filter-add-popup ref="filterAddPopup" @reload-tree-data="reloadTreeData" :search-tags="searchTags" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TreeFilter from '@/mixins/tree/filter';
import WSearchField from '@/components/form/SearchField';
import { defaultProps, treeType } from '@/constants/tree';

import WLogIndexTree from './LogIndexTree';
import WLogFilterTree from './LogFilterTree';
import WLogFilterSettingPopup from '../popup/LogFilterSettingPopup';
import WLogFilterAddPopup from '../popup/LogFilterAddPopup';

export default {
  name: 'WLogTree',
  mixins: [TreeFilter],
  props: {
    searchTags: Array,
  },
  components: {
    WSearchField,
    WLogIndexTree,
    WLogFilterTree,
    WLogFilterSettingPopup,
    WLogFilterAddPopup,
  },
  data() {
    return {
      treeType,
      treeTypes: [treeType.LOG_FILTER, treeType.LOG_INDEX],
      treeData: null,
      activeTreeType: 'log_filter',
      defaultProps,
      treeNode: {},
      filterTreeLoading: false,
      indexTreeLoading: false,
    };
  },
  computed: mapGetters(['userInfo']),
  methods: {
    onDragTreeNode(node) {
      this.$emit('dragTreeNode', node);
    },
    onDragEndTreeNode() {
      this.$emit('dragendTreeNode');
    },
    onClickTreeNode(data, node) {
      this.$emit('clickNode', data, node);
    },
    openFilterSettingPopup() {
      this.$refs.filterPopup.open();
    },
    openFilterAddPopup() {
      this.$refs.filterAddPopup.open();
    },
    reloadTreeData() {
      this.$refs.filterTree.loadData();
    },
    filterTree(value) {
      this.$refs.filterTree.filterTree(value);
      this.$refs.indexTree.filterTree(value);
    },
  },
};
</script>

<style module>
.h100 {
  height: 100%;
}
.tree {
  height: calc(100% - 95px) !important;
}
.btn-bar {
  border-top: 1px solid #F0F0F0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/LogTree.vue